import React, { useState, useEffect } from "react";
import "../styles/Hero.css";
import HeroImage from "../images/qiblalogo.png";
import Decoration from "../images/decoration.png";
import KaabaImage from "../images/kaaba.png";
import HeroDecoration from "./HeroDecoration";

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const slides = [
    {
      heading: "Welcome to the Qibla Platform!",
      text: "The Qibla Platform is a pioneering educational initiative aimed at integrating Islamic values with modern pedagogical practices. Our non-profit society extends its resources and programs internationally, serving Islamic schools worldwide with a unique blend of traditional teachings and contemporary technological advancements.",
    },
    {
      heading: "Our Mission",
      text: "To revitalize Islamic education by integrating Islamic values with modern pedagogical practices, fostering the development of morally grounded leaders prepared to excel in a diverse and dynamic world.",
    },
    {
      heading: "Our Vision",
      text: "To be a global leader in Islamic education, inspiring learners to reach their full potential and contribute positively to society guided by Islamic principles.",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true); // Start animation
      setTimeout(() => {
        setCurrentSlide(prev => (prev + 1) % slides.length); // Change slide
        setIsAnimating(false); // Reset animation
      }, 1000); // Match animation duration
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval); // Clean up interval on unmount
  }, [slides.length]);

  return (
    <div className="hero-section">
      {/* Decorative Element */}
      <HeroDecoration src={Decoration} />

      {/* Kaaba Overlay */}
      <img src={KaabaImage} alt="Kaaba" className="hero-kaaba" />

      <div className="hero-container">
        {/* Left Section: Slider */}
        <div className={`hero-left ${isAnimating ? "ripple-effect" : ""}`}>
          <h1 className={`hero-heading ${isAnimating ? "fade-out" : "fade-in"}`}>{slides[currentSlide].heading}</h1>
          <p className={`hero-text ${isAnimating ? "fade-out" : "fade-in"}`}>{slides[currentSlide].text}</p>
        </div>

        {/* Right Section: Image */}
        <div className="hero-right">
          <img src={HeroImage} alt="Qibla Platform" className="hero-image" />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
